import {BaseWidget} from "./BaseWidget";
import {createListRefRequest, defineModelForReferenceDataSource, referenceSuggestionTemp} from "./ReferenceWidget";
import {ajaxJSON} from "../common/NamaCommon";
import * as NamaURLS from '../constants/NamaURLS';
import {createSearchContextInfo} from "../actions/BaseDispatcher";

export class CodeFieldWidget extends BaseWidget {

    afterAttach() {
        super.afterAttach();
        let that = this;
        that.findElement().kendoAutoComplete({
            filter: "contains", dataSource: {
                transport: {
                    read: (options) => {
                        that.readFromServer(options);
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                schema: {
                    data: "page", total: "totalRecordsCount", model: defineModelForReferenceDataSource()
                },
            },
            dataTextField: "code",
            template: referenceSuggestionTemp,
            clearButton: false,
            change: (e) => {
                that.onEdit(that.readValueFromElement())
            },
            select: (e) => {
                that.owner.navigateToRef(e.dataItem, that.id);
            }
        });

    }

    readFromServer(options) {
        let that = this;
        let searchText = "";
        if (options.data && options.data.filter && options.data.filter.filters && options.data.filter.filters.length)
            searchText = options.data.filter.filters[0].value;
        let page = that.autoComplete().dataSource.page() - 1;
        let pageSize = that.autoComplete().dataSource.pageSize() || 25;
        let contextInfo = createSearchContextInfo("code", -1, that.owner);
        let request = createListRefRequest(contextInfo, null, searchText, that.owner.entityType, page, pageSize, null);
        ajaxJSON(NamaURLS.LIST_REFERENCES, request, (page) => {
            let result = {page: page, total: page.length};
            options.success(result);
        }, (e) => {
            options.error();
        })
    }

    setValueInElement(value) {
        let autoComplete = this.autoComplete();
        if(value === undefined)
            value = null;
        autoComplete.value(value);
    }

    /**
     * @returns {kendo.ui.AutoComplete}
     */
    autoComplete() {
        return this.findElement().data("kendoAutoComplete");
    }

    readValueFromElement() {
        return this.autoComplete().value();
    }

    shouldAddBlurHandler() {
        return false;
    }
}